import React from "react"
const CommonDesigns = ({ data }) => {
  const getFirstSectionImages = () => {
    if (data.firstSection.isWebImage) {
      return (
        <div className="relative min-w-[390px] md:min-w-[750px] xl:min-w-[916px]  ">
          <div className="absolute z-10 w-[288px] md:w-[500px] xl:w-[620px] bottom-[10%] md:bottom-[15%] xl:bottom-[10%] mx-auto    left-0 right-0  ">
            <img
              src={data.firstSection.tabImage.url}
              alt={data.firstSection.tabImage.label}
              className="w-full  "
              loading="lazy"
            />
          </div>
          <div className="absolute rounded-t-2xl z-0 w-[390px] md:w-[600px] xl:w-[916px] bottom-0 mx-auto top-[15%] md:top-[30%] xl:top-0 left-0 right-0  bg-white-200 -mt-12 md:-mt-[2.75rem]"></div>
        </div>
      )
    }
    return (
      <div className="relative w-[320px] xl:w-[440px]  ">
        <div className="absolute z-10 w-[115px]  md:w-[200px] xl:w-[227px] bottom-[35%] md:bottom-[15%] xl:bottom-[20%] mx-auto left-0 right-0  ">
          <img
            src={data.firstSection.mobileImage.url}
            alt={data.firstSection.mobileImage.label}
            className="w-full  "
            loading="lazy"
          />
        </div>
        <div className="absolute rounded-t-[999px] z-0 w-[265px] xl:w-[440px] bottom-0 mx-auto top-[15%] md:top-[45%] xl:top-[5%] left-0 right-0  bg-white-200"></div>
      </div>
    )
  }
  const getSecondSectionImages = () => {
    if (data.secondSection.mobileImages) {
      return (
        <div className="relative h-[50%] md:h-[65%]  xl:h-[60%]">
          <div className="absolute z-10 w-[390px] md:w-[500px] xl:w-[620px] top-[-5%] md:top-[20%] xl:top-[10%] mx-auto flex justify-center gap-8 md:gap-28 xl:gap-36  left-0 right-0  ">
            {data.secondSection.mobileImages.map((image, index) => (
              <div key={"mobile-image" + (index + 1)} className="">
                <img
                  src={image.url}
                  alt={image.label}
                  className="w-[112px] md:w-full   "
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          <div className="absolute rounded-b-2xl z-0 w-[390px] md:w-[600px] xl:w-[916px] top-0 mx-auto bottom-[40%] md:bottom-[60%] xl:bottom-[40%] left-0 right-0  bg-primary-100 -mt-12 md:-mt-[2.75rem]"></div>
        </div>
      )
    }

    return (
      <div className="relative  h-[50%] md:h-[65%]  xl:h-[60%]">
        <div className="absolute z-10 w-[360px] md:w-[500px] xl:w-[620px] top-[-5%] md:top-[20%] xl:top-[10%] mx-auto left-0 right-0  ">
          <img
            src={data.secondSection.webImage.url}
            alt={data.secondSection.webImage.label}
            className="w-full  "
            loading="lazy"
          />
        </div>
        <div className="absolute rounded-b-2xl z-0 w-[390px] md:w-[600px] xl:w-[916px] top-0 mx-auto bottom-[40%] md:bottom-[60%] xl:bottom-[40%] left-0 right-0  bg-primary-100 -mt-12 md:-mt-[2.75rem]"></div>
      </div>
    )
  }
  const getThirdSectionImages = () => {
    if (data.thirdSection.mobileImages) {
      return (
        <div className="relative h-[60%] md:h-[65%]  xl:h-[70%]">
          <div className="absolute justify-center md:h-[65%] xl:h-[100%] z-10 w-[390px]  md:w-[500px] xl:w-[620px] bottom-[10%] md:bottom-[0%] xl:bottom-[3%] mx-auto    left-0 right-0  flex gap-16  md:gap-28 xl:gap-36 ">
            {data.thirdSection.mobileImages.map((image, index) => (
              <div
                key={"mobile-image" + (index + 1)}
                className={`${index === 1 ? "self-end -mb-4 md:-mb-6 xl:mb-0" : "self-start -mt-4 md:-mt-6 xl:mt-0"}`}
              >
                <img
                  src={image.url}
                  alt={image.label}
                  className=" w-[112px] md:w-full "
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          <div className="absolute rounded-t-2xl z-0  w-[390px]  md:w-[600px] xl:w-[916px] bottom-0 mx-auto top-[-15%] md:top-[30%] xl:top-[0%] left-0 right-0  bg-white-200 -mt-12 md:-mt-[2.75rem]"></div>
        </div>
      )
    }
    return (
      <div className="relative  h-[60%] md:h-[65%]  xl:h-[70%]">
        <div className="absolute z-10 w-[288px] md:w-[500px] xl:w-[620px] bottom-[10%] md:bottom-[10%] xl:bottom-[10%] mx-auto    left-0 right-0  ">
          <img
            src={data.thirdSection.tabImage.url}
            alt={data.thirdSection.tabImage.label}
            className="w-full  "
            loading="lazy"
          />
        </div>
        <div className="absolute rounded-t-2xl z-0 w-[390px] md:w-[600px] xl:w-[916px] bottom-0 mx-auto top-[0%] md:top-[30%] xl:top-0 left-0 right-0  bg-white-200 -mt-12 md:-mt-[2.75rem]"></div>
      </div>
    )
  }

  const getFifthSectionImages = () => {
    if (data.fifthSection.mobileImages) {
      return (
        <div className="relative h-[60%] md:h-[65%]  xl:h-[70%]">
          <div className="absolute justify-center md:h-[65%] xl:h-[100%] z-10 w-[390px]  md:w-[500px] xl:w-[620px] bottom-[10%] md:bottom-[0%] xl:bottom-[3%] mx-auto    left-0 right-0  flex gap-16  md:gap-28 xl:gap-36 ">
            {data.fifthSection.mobileImages.map((image, index) => (
              <div
                key={"mobile-image" + (index + 1)}
                className={`${index === 1 ? "self-end -mb-4 md:-mb-6 xl:mb-0" : "self-start -mt-4 md:-mt-6 xl:mt-0"}`}
              >
                <img
                  src={image.url}
                  alt={image.label}
                  className=" w-[112px] md:w-full "
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          <div className="absolute rounded-t-2xl z-0  w-[390px]  md:w-[600px] xl:w-[916px] bottom-0 mx-auto top-[-15%] md:top-[30%] xl:top-[0%] left-0 right-0  bg-white-200 -mt-12 md:-mt-[2.75rem]"></div>
        </div>
      )
    }
    return (
      <div className="relative  h-[60%] md:h-[65%]  xl:h-[70%]">
        <div className="absolute z-10 w-[288px] md:w-[500px] xl:w-[620px] bottom-[10%] md:bottom-[10%] xl:bottom-[10%] mx-auto    left-0 right-0  ">
          <img
            src={data.fifthSection.tabImage.url}
            alt={data.fifthSection.tabImage.label}
            className="w-full  "
            loading="lazy"
          />
        </div>
        <div className="absolute rounded-t-2xl z-0 w-[390px] md:w-[600px] xl:w-[916px] bottom-0 mx-auto top-[0%] md:top-[30%] xl:top-0 left-0 right-0  bg-white-200 -mt-12 md:-mt-[2.75rem]"></div>
      </div>
    )
  }
  const getFourthSectionImage = () => {
    if (data.fourthSection.mobileImages) {
      return (
        <div className="relative h-[50%] md:h-[65%]  xl:h-[60%]">
          <div className="absolute z-10 w-[390px] md:w-[500px] xl:w-[620px] top-[-5%] md:top-[20%] xl:top-[10%] mx-auto flex justify-center gap-8 md:gap-28 xl:gap-36  left-0 right-0  ">
            {data.fourthSection.mobileImages.map((image, index) => (
              <div key={"mobile-image" + (index + 1)} className="">
                <img
                  src={image.url}
                  alt={image.label}
                  className="w-[112px] md:w-full   "
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          <div className="absolute rounded-b-2xl z-0 w-[390px] md:w-[600px] xl:w-[916px] top-0 mx-auto bottom-[40%] md:bottom-[60%] xl:bottom-[40%] left-0 right-0  bg-primary-100 -mt-12 md:-mt-[2.75rem]"></div>
        </div>
      )
    }

    return (
      <div className="relative  h-[50%] md:h-[65%]  xl:h-[60%]">
        <div className="absolute z-10 w-[360px] md:w-[500px] xl:w-[620px] top-[-5%] md:top-[20%] xl:top-[10%] mx-auto left-0 right-0  ">
          <img
            src={data.fourthSection.webImage.url}
            alt={data.fourthSection.webImage.label}
            className="w-full  "
            loading="lazy"
          />
        </div>
        <div className="absolute rounded-b-2xl z-0 w-[390px] md:w-[600px] xl:w-[916px] top-0 mx-auto bottom-[40%] md:bottom-[60%] xl:bottom-[40%] left-0 right-0  bg-primary-100 -mt-12 md:-mt-[2.75rem]"></div>
      </div>
    )
  }
  return (
    <div className="md:px-20 h-full md:pe-20 px-6 flex  pt-12 md:pt-[2.75rem] gap-24 md:gap-20 xl:gap-24 ">
      {/* First section */}
      <div className="md:items-stretch w-max min-w-[450px] md:min-w-[650px] xl:min-w-[1000px]  md:basis-full flex md:gap-12 xl:gap-24 flex-col">
        <div className="flex self-start md:w-[480px] xl:w-[597px] flex-col gap-4 md:gap-10 ">
          <div className="flex flex-col items-start gap-4 w-full">
            <div className="flex items-center gap-2">
              <div className="bg-blue-100 w-2 h-2 rounded-full"></div>
              <h4
                className={`text-gray-500 text-lg lg:text-2xl tracking-[-0.56px] md:tracking-tight-4% `}
              >
                Result
              </h4>
            </div>
            <h2
              className={`text-gray-100 text-3xl md:text-5xl lg:text-8xl tracking-[-.96px] md:tracking-tight-2% lg:tracking-tight-7%`}
            >
              Visual Highlights
            </h2>
          </div>
        </div>
        <div className="self-start w-full flex-grow  basis-full   ">
          <div className="flex flex-grow h-full gap-12 md:gap-16 xl:gap-24">
            <div className="flex w-[245px] md:min-w-[280px] xl:min-w-[400px] mb-12 md:mb-20 xl:mb-12 items-end justify-end text-end flex-col md:gap-2 ">
              <div className="text-2xl text-black-500 tracking-[-.72px] md:tracking-[0.96px]">
                {data.firstSection.title}
              </div>
              <div className="text-[1.08rem] md:text-lg leading-tight text-black-300  md:max-w-[85%] xl:max-w-[65%]">
                {data.firstSection.description}
              </div>
            </div>
            {getFirstSectionImages()}
          </div>
        </div>
      </div>
      {/* Second section */}
      <div className="self-start h-full flex-grow    w-max min-w-[450px] md:min-w-[650px] xl:min-w-[950px]  ">
        <div className="flex flex-col h-full gap-20 md:gap-24 xl:gap-24">
          {getSecondSectionImages()}
          <div className="flex mb-4 md:mb-8 xl:mb-12 items-start justify-start  flex-col md:gap-2 w-[343px] md:w-[600px] xl:w-[916px] mx-auto">
            <div className="text-2xl text-black-500 tracking-[-.72px] md:tracking-[0.96px]">
              {data.secondSection.title}
            </div>
            <div className="text-[1.08rem] md:text-lg leading-tight text-black-300  md:max-w-[85%] xl:max-w-[65%]">
              {data.secondSection.description}
            </div>
          </div>
        </div>
      </div>
      {/* Third section */}
      <div className="self-start h-full flex-grow    w-max min-w-[450px] md:min-w-[650px] xl:min-w-[950px]  ">
        <div className="flex flex-col justify-end flex-grow h-full gap-24 md:gap-24 xl:gap-24">
          <div className="flex md:mt-16 xl:mt-20 items-end text-end justify-start  flex-col md:gap-2 w-[343px]  md:w-[600px] xl:w-[916px] ml-auto">
            <div className="text-[1.08rem] md:text-lg leading-tight text-black-300  md:max-w-[85%] xl:max-w-[65%]">
              {data.thirdSection.description}
            </div>
          </div>
          {getThirdSectionImages()}
        </div>
      </div>
      {data.fourthSection && (
        <div className="self-start h-full flex-grow    w-max min-w-[450px] md:min-w-[650px] xl:min-w-[950px]  ">
          <div className="flex flex-col h-full gap-20 md:gap-24 xl:gap-24">
            {getFourthSectionImage()}
            <div className="flex mb-4 md:mb-8 xl:mb-12 items-start justify-start  flex-col md:gap-2 w-[343px] md:w-[600px] xl:w-[916px] mx-auto">
              <div className="text-2xl text-black-500 tracking-[-.72px] md:tracking-[0.96px]">
                {data.fourthSection.title}
              </div>
              <div className="text-[1.08rem] md:text-lg leading-tight text-black-300  md:max-w-[85%] xl:max-w-[65%]">
                {data.fourthSection.description}
              </div>
            </div>
          </div>
        </div>
      )}
      {data.fifthSection && (
        <div className="self-start h-full flex-grow    w-max min-w-[450px] md:min-w-[650px] xl:min-w-[950px]  ">
          <div className="flex flex-col justify-end flex-grow h-full gap-24 md:gap-24 xl:gap-24">
            <div className="flex md:mt-16 xl:mt-20 items-end text-end justify-start  flex-col md:gap-2 w-[343px]  md:w-[600px] xl:w-[916px] ml-auto">
              <div className="text-[1.08rem] md:text-lg leading-tight text-black-300  md:max-w-[85%] xl:max-w-[65%]">
                {data.fifthSection.description}
              </div>
            </div>
            {getFifthSectionImages()}
          </div>
        </div>
      )}
      {data.imageSection}
    </div>
  )
}

export default CommonDesigns
